import { ActionHandler } from "../index";
import { dispatchMedProductEligibilityLoad } from "src/utils/medProductEligibilityLoad";
import { shouldApplyVendorEngineGate } from "src/utils/userSegment/features";

const COLD_LOAD_TIMEOUT_MS = 5000;

/**
 * Ensures the med product eligibility verdicts are in Redux before pages that
 * consult them (plan selection, recommended med plans). Idempotent: the
 * dispatcher only fetches products without a resolved verdict, so this is a
 * no-op on the warm path and only blocks — capped at 5s — on a cold entry.
 * On timeout or failure the verdict stays unresolved (the vendor gate
 * fail-closes for branded) and a late response still lands in Redux for
 * later checkpoints.
 */
export const ensureMedProductEligibility: ActionHandler = async ({ store }) => {
  if (!shouldApplyVendorEngineGate()) {
    return;
  }

  await new Promise<void>((resolve) => {
    const timer = setTimeout(resolve, COLD_LOAD_TIMEOUT_MS);
    dispatchMedProductEligibilityLoad(store.dispatch)
      .catch(() => {})
      .finally(() => {
        clearTimeout(timer);
        resolve();
      });
  });
};
